import z from "zod";

/**
 * CategoriaAssistenciaSchema
 */

export const CategoriaAssistenciaSchema = z.object({
  status: z.coerce.number().default(1),
  categoria: z.string().nonempty("Este campo deve ser preenchido!"),
});

/**
 * CategoriaAssistenciaForm
 */

export type CategoriaAssistenciaForm = z.infer<typeof CategoriaAssistenciaSchema>;